import * as React from 'react';
export const IcOlympics = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.71 12.29A1 1 0 0016 12H8a1 1 0 00-1 1v2a1 1 0 001 1h.72L10 21.24a1 1 0 001 .76h2a1 1 0 001-.76L15.28 16H16a1 1 0 001-1v-2a1 1 0 00-.29-.71zM8.15 10H9c0-2 1.72-1.11 2-3.28a.53.53 0 01.66-.42C13.81 6.89 14 9 14 10h1a1 1 0 001-1 8.12 8.12 0 00-4.6-6.84 1 1 0 00-1.48 1.01c.39 2.12-2.06 3.32-2.75 5.62A1 1 0 008.15 10z'
      fill='currentColor'
    />
  </svg>
);
